import { View } from 'backbone';

import targetTemplate from 'properties/main/target.ejs';


class MainTargetView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = targetTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change select[name="target"]' : 'updateAttributes'
        };

        // Add needed property
        if (!this.model.get('target')) {
            this.model.set('target', 'new', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        console.log(propName);
        console.log(propVal);
        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(this.model.get('target')) {
            $('#target').find("option[value='"+this.model.get('target')+"']").attr('selected', true);
        }
        
        this.delegateEvents();
        return this;
    }

}

export default MainTargetView;
